// Text measurement shared by the engraver (cached per font+text).

let ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D | null = null;
const cache = new Map<string, number>();

export function measureText(text: string, font: string): number {
  const key = font + '\u0000' + text;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  if (!ctx) {
    ctx = typeof OffscreenCanvas !== 'undefined' ? new OffscreenCanvas(4, 4).getContext('2d') : document.createElement('canvas').getContext('2d');
  }
  let w = text.length * 7;
  if (ctx) {
    ctx.font = font;
    w = ctx.measureText(text).width;
  }
  if (cache.size > 5000) cache.clear();
  cache.set(key, w);
  return w;
}

export function clearMeasureCache(): void {
  cache.clear();
}
